import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/static/logo.svg"
      style={{maxWidth: 120}}
      {...props}
    />
  );
}

export default Logo;
